module.exports = __webpack_public_path__ + "img/golovinskie.b6d37c6c.png";